// Vendor imports
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
const { formatCount, pluralize } = require('shared/string-utils')
// Client V2 common imports
const { InterestFollowCapsuleButton } = require('client-v2/common/components/buttons')
const { usePropsEventCallback } = require('client-v2/common/hooks/callbacks')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('InterestProfileSeriesFeedHeader')

const followers = pluralize('follower')

/**
 *
 * @param {Object} props
 * @param {string} props.className
 * @param {Object} props.interest
 * @param {function} props.onFollowClick
 * @returns {React.ElementType}
 */
function InterestProfileSeriesFeedHeader(props) {
  const { interest } = props
  const handleFollowClick = usePropsEventCallback(props, 'onFollowClick')
  return (
    tag('div', {
      className: classNames(
        props.className,
        bem.block()
      )
    },
      tag('div', {
        className: bem.element('title')
      },
        interest.name
      ),
      tag('div', {
        className: bem.element('followers')
      },
        `${formatCount(interest.followersCount)}`,
        ` ${followers(interest.followersCount)}`
      ),
      tag(InterestFollowCapsuleButton, {
        className: bem.element('follow-button'),
        checked: interest.isFollowing,
        onClick: handleFollowClick
      })
    )
  )
}

module.exports = InterestProfileSeriesFeedHeader
